import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-search",
  "use": "icon-s-search-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-search\"><path d=\"M20.053 8.044c0 3.36-2.729 6.094-6.083 6.094s-6.083-2.734-6.083-6.094 2.73-6.094 6.083-6.094 6.083 2.734 6.083 6.094M7.941 13.356q.32.366.685.692l-5.184 5.195-.689-.69zM13.971 0C9.542 0 5.94 3.609 5.94 8.044c0 1.278.305 2.543.883 3.673L0 18.553 3.442 22l6.811-6.823a8.04 8.04 0 0 0 3.717.911c4.428 0 8.03-3.608 8.03-8.044C22 3.61 18.398 0 13.97 0\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol